import React from 'react';
import '../styles/pages/Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="container">
          <h1 className="contact-title">Get In Touch</h1>
          <p className="contact-subtitle">We're here to help you with all your printing needs</p>
        </div>
      </div>

      <div className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Contact Information</h2>
              <p className="contact-description">
                Reach out to us for premium printing solutions, quotes, or any questions you might have. 
                We're always ready to assist you with your printing requirements.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <div className="contact-text">
                    <h3>Address</h3>
                    <p>
                      Infront of Govt. B.ed College,<br />
                      near Chhatrasal Chowraha,<br />
                      District Hospital Shop No. 19,<br />
                      Chhatarpur (M.P.) 471001
                    </p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <div className="contact-text">
                    <h3>Phone</h3>
                    <p>
                      Proprietor: Deepak Chaurasiya<br />
                      <a href="tel:+919993143569">+91 9993143569</a>
                    </p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">📧</div>
                  <div className="contact-text">
                    <h3>Email</h3>
                    <p>
                      <a href="mailto:gyanirajoffset1@gmail.com">gyanirajoffset1@gmail.com</a>
                    </p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">🕒</div>
                  <div className="contact-text">
                    <h3>Working Hours</h3>
                    <p>10:00 AM to 9:00 PM</p>
                  </div>
                </div>
              </div>

            </div>

            <div className="contact-form-section">
              <h2>Send Us a Message</h2>
              <form className="contact-form"> 
                <div className="form-group">
                  <input type="text" placeholder="Your Name" required />
                </div>
                <div className="form-group">
                  <input type="email" placeholder="Your Email" required />
                </div>
                <div className="form-group">
                  <input type="tel" placeholder="Your Phone" required />
                </div>
                <div className="form-group">
                  <select required>
                    <option value="">Select Service</option>
                    <option value="flex-printing">Flex Printing</option>
                    <option value="visiting-cards">Visiting Cards</option>
                    <option value="wedding-cards">Wedding Cards</option>
                    <option value="pamphlets">Pamphlets/Flyers</option>
                    <option value="brochures">Brochures</option>
                    <option value="signage">Signage Services</option>
                  </select>
                </div>
                <div className="form-group">
                  <textarea placeholder="Your Requirements" rows="5" required></textarea>
                </div>
                <button type="submit" className="submit-btn">Send Message</button>
              </form>
              <br/>
              <h2> Find Us here </h2>
              <div className="social-link">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509198!2d144.9537353153164!3d-37.81627997975157!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11f1b3%3A0x5045675218ceed0!2sGyaniraj%20Offset!5e0!3m2!1sen!2sin!4v1616161616161!5m2!1sen!2sin"
                  width="400"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
